<template>
  <div class="bg-page-container">
    <!-- 页面头部 -->
    <div class="bg-page-header">
      <div class="header-title">
        <i class="el-icon-user-solid"></i>
        <span>用户管理</span>
      </div>
      <div class="header-actions">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="createInit">新增用户</el-button>
      </div>
    </div>

    <!-- 查询区域 -->
    <div class="bg-query-section">
      <div class="query-form">
        <el-form :inline="true" size="small">
          <el-form-item label="账号">
            <el-autocomplete
              v-model="keyword"
              :fetch-suggestions="querySearch"
              placeholder="请输入账号"
              @select="handleSelect"
              clearable
              style="width: 250px">
              <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
            </el-autocomplete>
          </el-form-item>
        </el-form>
        <div class="query-actions">
          <el-button type="primary" icon="el-icon-search" size="small" @click="getUsers">查询</el-button>
          <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="bg-table-section">
      <el-table
        :data="userList"
        v-loading="loading"
        :height="tableHeight"
        class="bg-table"
        stripe>
        <el-table-column prop="account" label="账号" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="120" align="center">
        </el-table-column>
        <el-table-column prop="schoolName" label="机构名称" min-width="180" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="expirationDate" label="有效期" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.expirationDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roles" label="角色" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-for="role in scope.row.roles.split(',')" :key="role" size="small" effect="plain" style="margin: 0 2px;">
              {{ role }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="deleteFlag" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.deleteFlag === 0 ? 'success' : 'info'" size="small" effect="plain">
              {{ scope.row.deleteFlag === 0 ? '生效' : '删除' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="modifyUser(scope.$index, scope.row)">
              修改
            </el-button>
            <el-button
              type="text"
              size="small"
              class="text-danger"
              icon="el-icon-circle-close"
              @click="disableUser(scope.$index, scope.row)">
              禁用
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="bg-pagination"
        background
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="currentChange"
        :total="totalCount"
        :page-sizes="[15, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <!-- 空状态 -->
    <bg-empty
      v-if="!loading && userList.length === 0"
      icon="el-icon-user-solid"
      description="暂无用户数据"
      hint="请使用查询条件筛选或添加新用户">
    </bg-empty>

    <!-- 新增用户对话框 -->
    <el-dialog title="新增用户" :visible.sync="dialogVisible" width="500px" class="bg-dialog" :before-close="handleClose">
      <el-form ref="form" :model="user" label-width="90px" size="small">
        <el-form-item label="账号" required>
          <el-input v-model="user.account" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" required>
          <el-input v-model="user.pwd" type="password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="user.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="机构名称">
          <el-input v-model="user.schoolName" placeholder="请输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
            v-model="user.expirationDate"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="selectUsers" multiple placeholder="请选择角色" style="width: 100%">
            <el-option v-for="item in user.roles" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户对话框 -->
    <el-dialog title="修改用户" :visible.sync="dialogmodVisible" width="500px" class="bg-dialog" :before-close="handleClose">
      <el-form ref="form" :model="muser" label-width="90px" size="small">
        <el-form-item label="账号">
          <el-input v-model="muser.account" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="muser.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="机构名称">
          <el-input v-model="muser.schoolName" placeholder="请输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
            v-model="muser.expirationDate"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="selectRoles" multiple placeholder="请选择角色" style="width: 100%">
            <el-option v-for="item in muser.roles" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogmodVisible = false">取消</el-button>
        <el-button type="primary" @click="modifyUserPost" :loading="loading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'
import BgEmpty from '@/components/common/BgEmpty'

export default {
  name: 'Users',
  components: {
    BgEmpty
  },
  data () {
    return {
      tableHeight: 0,
      addalertTip: false,
      alertTip: false,
      keyword: '',
      loading: false,
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      userList: [],
      dialogVisible: false,
      dialogmodVisible: false,
      user: {},
      muser: {
        account: '',
        mobile: '',
        schoolName: '',
        expirationDate: '',
        roles: [{ label: '管理员', value: 'admin' }, { label: '用户', value: 'user' }]
      },
      selectUsers: [],
      selectRoles: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        },
        {
          text: '一月后',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30)
            picker.$emit('pick', date)
          }
        },
        {
          text: '一年后',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  created () {
    this.tableHeight = (window.innerHeight - 240)
    this.getUsers()
  },
  methods: {
    createInit () {
      this.dialogVisible = true
      this.addalertTip = false
      this.user = {
        account: '',
        pwd: '',
        mobile: '',
        schoolName: '',
        expirationDate: '',
        roles: [{ label: '管理员', value: 'admin' }, { label: '用户', value: 'user' }]
      }
      this.selectUsers = []
    },
    onSubmit () {
      this.loading = true
      this.user.roles = this.selectUsers
      this.$axios.post(api.createUser, this.user)
        .then(res => {
          if (res.data.result === 1) {
            this.dialogVisible = false
            this.getUsers()
            this.$message({ message: '创建成功', type: 'success' })
          } else {
            this.$message({ message: '用户已存在', type: 'warning' })
          }
          this.loading = false
        })
    },
    getUsers () {
      this.loading = true
      this.$axios.post(api.getUsers, { PageIndex: this.pageIndex, PageSize: this.pageSize, Account: this.keyword })
        .then(res => {
          this.loading = false
          this.userList = res.data.result.items
          this.totalCount = res.data.result.totalCount
        })
    },
    disableUser (id, row) {
      this.$confirm('确定要禁用该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let param = new URLSearchParams()
        param.append('account', row.account)
        this.$axios.post(api.disableUser, param)
          .then(res => {
            this.$message({ message: '禁用成功', type: 'success' })
            this.getUsers()
          })
      })
    },
    modifyUser (id, row) {
      this.dialogmodVisible = true
      this.muser.account = row.account
      this.muser.mobile = row.mobile
      this.muser.schoolName = row.schoolName
      this.muser.expirationDate = row.expirationDate
      this.selectRoles = row.roles ? row.roles.split(',') : []
      this.alertTip = false
    },
    modifyUserPost () {
      this.loading = true
      this.$axios.post(api.modifyUser, { account: this.muser.account, mobile: this.muser.mobile, schoolName: this.muser.schoolName, roles: this.selectRoles, expirationDate: this.muser.expirationDate })
        .then(res => {
          this.loading = false
          this.dialogmodVisible = false
          this.$message({ message: '修改成功', type: 'success' })
          this.getUsers()
        })
    },
    handleClose () {
      this.dialogmodVisible = false
      this.dialogVisible = false
      this.alertTip = false
      this.addalertTip = false
    },
    handleSelect (item) {
      this.keyword = item.Id
      this.getUsers()
    },
    handleIconClick () {
      this.getUsers()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getUsers()
    },
    querySearch (keyword, callback) {
      if (keyword === '') {
        return
      }
      var queryList = []
      this.$axios.get(api.autocomplete(this.keyword))
        .then(res => {
          res.data.result.forEach((item, index) => {
            queryList.push({ value: item.account, Id: item.account })
          })
        })
      callback(queryList)
    },
    formatDate (dateStr) {
      if (!dateStr) return '-'
      var date = new Date(Date.parse(dateStr.replace(/-/g, '/').replace('T', ' ')))
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    },
    currentChange (current) {
      this.pageIndex = current
      this.getUsers()
    },
    resetQuery () {
      this.keyword = ''
      this.pageIndex = 1
      this.getUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.bg-page-container {
  @include page-container;
}

.bg-page-header {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);

  .header-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-lg;
    font-weight: 600;
    color: var(--text-primary);

    i {
      font-size: $font-size-xl;
      color: $primary-color;
    }
  }
}

.bg-query-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  padding: $spacing-lg;
  margin-bottom: $spacing-lg;
  box-shadow: var(--shadow-base);

  .query-form {
    @include flex-between;
    flex-wrap: wrap;
    gap: $spacing-md;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .query-actions {
    display: flex;
    gap: $spacing-sm;
  }
}

.bg-table-section {
  @include table-section;

  .bg-table {
    border-radius: $border-radius-sm;
    overflow: hidden;

    .el-table__header {
      background: var(--gradient-header);

      th {
        font-weight: 600;
        color: var(--text-primary);
        background: transparent;
      }
    }

    .text-danger {
      color: $danger-color;

      &:hover {
        color: $danger-dark;
      }
    }
  }
}

.bg-pagination {
  margin-top: $spacing-lg;
  text-align: center;
}

// 响应式适配
@media (max-width: $screen-md) {
  .bg-query-section {
    .query-form {
      flex-direction: column;
      align-items: stretch;

      .query-actions {
        justify-content: flex-start;
      }
    }
  }
}

@media (max-width: $screen-sm) {
  .bg-page-header {
    flex-direction: column;
    gap: $spacing-md;
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/Users.vue